import { OrganizationDetailsResponse } from '@core/models/org.model';
import { UserProfile } from '@core/models/user.model';
import {
  EnterpriseOnboardingProgress,
  EnterpriseOnboardingRouteStep,
} from '@features/enterprises/constants/enterprise-onboarding.constants';

export interface IncompleteResumeTarget {
  routeStep: EnterpriseOnboardingRouteStep;
  progress: EnterpriseOnboardingProgress;
  requiresOrganizationFetch: boolean;
}

export function resolveIncompleteEnterpriseResume(profile: UserProfile): IncompleteResumeTarget {
  const status = (profile.workFlowStatus || '').toUpperCase().trim();

  switch (status) {
    case 'PENDING_ACTIVATION':
    case 'VERIFICATION_PENDING':
      return {
        routeStep: 'verify-otp',
        progress: EnterpriseOnboardingProgress.AwaitingOtp,
        requiresOrganizationFetch: false,
      };
    case 'PENDING_ORGANIZATION':
      return {
        routeStep: 'add-organization',
        progress: EnterpriseOnboardingProgress.OtpVerified,
        requiresOrganizationFetch: false,
      };
    case 'PENDING_SUBSCRIPTION':
      return {
        routeStep: 'add-plan',
        progress: EnterpriseOnboardingProgress.OrganizationCreated,
        requiresOrganizationFetch: !!profile.organizationId,
      };
    case 'SUBSCRIBED':
    case 'SUBSCRIBED_PASSIVE':
      return {
        routeStep: 'payment-capture',
        progress: EnterpriseOnboardingProgress.SubscriptionCreated,
        requiresOrganizationFetch: !!profile.organizationId,
      };
    default:
      break;
  }

  if (!profile.mobileVerified) {
    return {
      routeStep: 'verify-otp',
      progress: EnterpriseOnboardingProgress.AwaitingOtp,
      requiresOrganizationFetch: false,
    };
  }

  if (!profile.organizationId) {
    return {
      routeStep: 'add-organization',
      progress: EnterpriseOnboardingProgress.OtpVerified,
      requiresOrganizationFetch: false,
    };
  }

  return {
    routeStep: 'add-plan',
    progress: EnterpriseOnboardingProgress.OrganizationCreated,
    requiresOrganizationFetch: true,
  };
}

export function buildOrganizationStubFromProfile(
  profile: UserProfile,
  orgDetails?: OrganizationDetailsResponse | null,
) {
  if (orgDetails?.organizationResponse) {
    return orgDetails.organizationResponse;
  }

  if (!profile.organizationId) {
    return null;
  }

  return {
    organizationId: profile.organizationId,
    organizationName: profile.organizationName || '',
    organizationType: '',
    address: profile.address,
    timeZone: profile.timeZone || '',
    baseCurrency: '',
    status: '',
    auditInfo: profile.auditInfo,
  };
}
